FreeMembers = LP.module 'FreeMembers'

FreeMembers.showSignupModal = ->
  # to not allow page scrolling when the free-signup-result modal is rendered.
  # hide & show below happen too fast and modal-open class sometimes fails to
  # be added properly.
  $('.modal').on 'hidden.bs.modal', (e) ->
    $('body').addClass('modal-open')

  $('.modal.in').modal('hide') # close all open modals
  $('#free-signup-modal').modal('show')

  $('#free-signup-modal').on 'shown.bs.modal', (e) ->
    $(@).find('input:visible:first').focus()
    # Revert the logic once the freemium modal is displayed.
    # Otherwise, opening a RRP modal will disable the scrolling.
    $('.modal').on 'hidden.bs.modal', (e) ->
      $('body').removeClass('modal-open')

  FreeMembers.setupFormValidation()

FreeMembers.triggerSubmit = ->
  $("#free-signup-form").submit()

FreeMembers.setupFormValidation = ->
  $("#free-signup-form").validate({
    rules: {
      'user[email]': {
        required: true,
        email: true
      },
      'user[password]': {
        required: true,
        minlength: 5
      }
    },
    messages: {
      'user[email]': {
        email: "Please provide a valid email address."
      }
    },
    submitHandler: (form) ->
      window.doubleSubmitHandler(form)
  })
